import { define } from 'remount'
import { SocialCardBuilder } from './SocialCardBuilder.tsx'
import bootstrap from 'bootstrap'

define({ 'social-card-builder': SocialCardBuilder })
